"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchServiceFactory = exports.SearchService = exports.SearchTextParser = void 0;
/**
 * Search text parser that extracts special syntax patterns
 * Supports formats: realm:value, account:value, code:value, hint:value, point:value
 * Both colon (:) and equals (=) separators are supported
 */
var SearchTextParser = /** @class */ (function () {
    function SearchTextParser() {
    }
    /**
     * Parse search text and extract special parameter syntax
     * Returns cleaned text and extracted parameters
     */
    SearchTextParser.parse = function (searchText) {
        if (!searchText || typeof searchText !== 'string') {
            return { text: searchText || null, params: {} };
        }
        var trimmed = searchText.trim();
        var params = {};
        // Check each pattern for a complete match
        for (var _i = 0, _a = this.PATTERNS; _i < _a.length; _i++) {
            var pattern = _a[_i];
            var match = trimmed.match(pattern.regex);
            if (match) {
                params[pattern.key] = match[1];
                return { text: null, params: params };
            }
        }
        // No pattern matched - return original text
        return { text: trimmed, params: {} };
    };
    SearchTextParser.PATTERNS = [
        { key: 'realm', regex: /^realm[:=](\S+)$/i },
        { key: 'account', regex: /^account[:=](\S+)$/i },
        { key: 'code', regex: /^code[:=](\S+)$/i },
        { key: 'hint', regex: /^hint[:=](\S+)$/i },
        { key: 'point', regex: /^point[:=](\S+)$/i },
    ];
    return SearchTextParser;
}());
exports.SearchTextParser = SearchTextParser;
var SearchService = /** @class */ (function () {
    function SearchService($http, $q) {
        this.$http = $http;
        this.$q = $q;
    }
    /**
     * Parse search text for special parameter syntax
     */
    SearchService.prototype.parseSearchText = function (searchText) {
        return SearchTextParser.parse(searchText);
    };
    /**
     * Parse search parameters from URL path
     * Supports /s/{encoded-json} format
     */
    SearchService.prototype.parseSearchFromUrl = function (location) {
        try {
            var path = (location || window.location).pathname;
            if (path.startsWith('/s/')) {
                var encoded = path.substring(3); // Remove /s/
                var decoded = decodeURIComponent(encoded);
                var params = JSON.parse(decoded);
                return params;
            }
        }
        catch (error) {
            console.error('Failed to parse search from URL:', error);
        }
        return null;
    };
    /**
     * Perform search with given parameters
     */
    SearchService.prototype.search = function (params) {
        var _this = this;
        return this.$http
            .get('/api1.php', {
            params: __assign({ json: 'search' }, params)
        })
            .then(function (response) {
            if (response.data.Result === 'OK') {
                return response.data;
            }
            else {
                return _this.$q.reject(new Error(response.data.Message || 'Search failed'));
            }
        });
    };
    /**
     * Load initial search from URL or viewMode.
     * Text/tag searches default to hide-completed (done:0).
     * Direct pnid /view opens show all rows (including completed) so the root note is never empty.
     */
    SearchService.prototype.loadInitialSearch = function (viewMode, location) {
        // First check URL for /s/ params
        var urlParams = this.parseSearchFromUrl(location);
        if (urlParams) {
            var hasPnid = urlParams.pnid != null &&
                urlParams.pnid !== '' &&
                Number(urlParams.pnid) > 0;
            // Preserve explicit done from URL; only default hide-done for non-id searches
            if (urlParams.done !== undefined && urlParams.done !== null && urlParams.done !== '') {
                return __assign({}, urlParams);
            }
            if (hasPnid) {
                return __assign({}, urlParams);
            }
            return __assign(__assign({}, urlParams), { done: 0 });
        }
        // Fallback to viewMode params
        var searchObject = {};
        if (viewMode.initialSearchText) {
            searchObject.initialSearch = viewMode.initialSearchText;
        }
        if (viewMode.initialSearchOnlyPNID && viewMode.initialSearchOnlyPNID > 0) {
            searchObject.pnid = viewMode.initialSearchOnlyPNID;
        }
        // Hide completed for free-text initial search; not for /view/pnid/N
        if (searchObject.pnid == null && searchObject.initialSearch) {
            searchObject.done = 0;
        }
        // Only return if we have actual search params
        if (Object.keys(searchObject).length > 0) {
            return searchObject;
        }
        return null;
    };
    SearchService.$inject = ['$http', '$q'];
    return SearchService;
}());
exports.SearchService = SearchService;
function SearchServiceFactory($http, $q) {
    return new SearchService($http, $q);
}
exports.SearchServiceFactory = SearchServiceFactory;
SearchServiceFactory.$inject = ['$http', '$q'];
